<template>
  <div id="pageFoot" class="footer-sec" />
</template>
<script>
import { loadJS } from "@/libs/load";

export default {
  name: "Footer",
  mounted() {
     loadJS(
      "https://www.seayoo.com/public/footer/ffbewotv.js?v="+ new Date().getTime()
    );
  }
};
</script>

